import { Chip, Stack } from "@mui/material";
import React from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { globalTheme } from "../../styles";

interface OrderStateProps extends CustomCellRendererProps {
  refreshData: () => void;
  setSnackBar: (snackBar: { open: boolean; message: string; severity: string }) => void;
}

export const OrderStateCell = React.memo((params: OrderStateProps) => {
  const { data } = params;

  const unshippedStatuses = ["ReadyToPrint", "Unshipped", "Error"];

  // Helper function to determine tag text and color based on conditions
  const getTagDetails = () => {
    if (
      data.pickingStatus === "Unpicked" &&
      unshippedStatuses.includes(data.shippingStatus) &&
      data.issueStatus === "NoIssue" &&
      data?.userId === ""
    ) {
      return { label: "Unpicked", color: globalTheme.secondaryColor };
    }
    if (
      data.pickingStatus === "Unpicked" &&
      unshippedStatuses.includes(data.shippingStatus) &&
      data.issueStatus === "NoIssue" &&
      data?.userId !== ""
    ) {
      return { label: "Assigned", color: globalTheme.blue };
    }
    if (unshippedStatuses.includes(data.shippingStatus) && data.issueStatus === "Issue") {
      return { label: "Issues", color: globalTheme.orange };
    }
    if (data.shippingStatus === "Cancelled") {
      return { label: "Cancelled", color: globalTheme.red };
    }
    if (unshippedStatuses.includes(data.shippingStatus) && data.issueStatus === "OnHold") {
      return { label: "On Hold", color: globalTheme.orange };
    }
    if (unshippedStatuses.includes(data.shippingStatus) && data.pickingStatus === "Picked" && data.issueStatus === "NoIssue") {
      return { label: "All Picked Orders", color: globalTheme.green };
    }
    if (data.shippingStatus === "PickAndPack") {
      return { label: "Pick and Pack", color: globalTheme.primaryColor };
    }
    if (data.shippingStatus === "Shipped") {
      return { label: "Shipped", color: globalTheme.green };
    }
    return { label: "Unknown", color: globalTheme.border };
  };

  const tagDetails = getTagDetails();

  return (
    <Stack direction="row" justifyContent="center" alignItems="center">
      <Chip
        label={tagDetails.label}
        style={{
          backgroundColor: tagDetails.color,
          color: tagDetails.color === globalTheme.white ? "black" : "white",
        }}
        variant="outlined"
        size="small"
      />
    </Stack>
  );
});
